import './App.css';
import { Button } from './components/buttons';

function App() {

  return (
    <div className="App">
      <Button link="login" title="login"/>
    </div>
  );
}

export default App;
